import React, { useState } from 'react';
import MuiTooltip from '@mui/material/Tooltip';
import { useIsTouchDevice } from '../../Components/BreakpointContext/BreakpointContextUtils';

interface IProps {
  id?: string;
  children: React.ReactElement<any>;
  /** Texten som visas i tooltipen, normalt en sträng och en tom sträng om ingen tooltip ska visas.
   *  Null/undefined tar bort hela komponenten som en optimering men man tappar då ev. state i underliggande komponent */
  title: React.ReactNode;
  placement?: TooltipPlacement;
  enterDelay?: number;
  enterTouchDelay?: number;
  enableFocusListener?: boolean;
  enableClickOnTouch?: boolean;
}

export type TooltipPlacement =
  | 'bottom-end'
  | 'bottom-start'
  | 'bottom'
  | 'left-end'
  | 'left-start'
  | 'left'
  | 'right-end'
  | 'right-start'
  | 'right'
  | 'top-end'
  | 'top-start'
  | 'top';

export const EDTooltip: React.FC<React.PropsWithChildren<IProps>> = props => {
  const isTouch = useIsTouchDevice();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    if (props.title == null || props.title === '') return;
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return props.title != null ? (
    <MuiTooltip
      id={props.id}
      title={props.title}
      placement={props.placement}
      enterDelay={props.enterDelay}
      enterTouchDelay={
        props.enableClickOnTouch && isTouch ? 0 : props.enterTouchDelay
      }
      disableFocusListener={!props.enableFocusListener}
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      disableInteractive
    >
      {props.children}
    </MuiTooltip>
  ) : (
    props.children
  );
};

export default EDTooltip;
